/**
 * Shop functionalities (cart, check-out and thanks page)
 *
 * These scripts are used on a third party developed pages
 */

ready().then(function () {
    const cartFunctions = () => {

        var executedFn = false;

        /*
        * If we have more then 3 products - we like to add a read more and some visibility classes
        * we handle the rest with CSS3 animations
        */
        const addReadMoreProducts = () => {
            const productsummary = document.querySelector('.col:nth-child(2) .product-summary-container'); // .col:nth-child(2) specifically for the sidebar and not the main column

            if (typeof (productsummary) != 'undefined' && productsummary != null && productsummary.children.length > 3 && executedFn == false) {

                executedFn = true;

                const readmore = document.createElement('div');
                const p = document.createElement('p');

                productsummary.classList.add('has-readmore', 'is-readmore-closed');
                readmore.classList.add('read-more');

                productsummary.appendChild(readmore);
                readmore.appendChild(p);
                p.outerHTML = '<p class="read-more-text has-icon icon-arrow-down">Toon alle artikelen</>';

                readmore.onclick = () => {
                    productsummary.classList.toggle('is-readmore-closed');
                }
            } else if (typeof (productsummary) != 'undefined' && productsummary != null && productsummary.children.length <= 3) {
                const readmore = document.querySelector('.read-more');
                if (typeof (readmore) != 'undefined' && readmore != null) {
                    readmore.remove();
                }
            }
        }

        /*
        * if we have no products in the cart - we would like to show a cart empty text
        */
        const whenEmptyCart = () => {
            var productsummary = document.querySelector('.product-summary-container');
            var p = document.createElement('p');
            var main = document.querySelector('main');

            if (typeof (productsummary) != 'undefined' && productsummary != null && productsummary.children.length < 0) {
                main.classList.add('is-empty');
                productsummary.appendChild(p);
                p.innerHTML = 'Je winkelwagen is leeg';
            }
        }


        /*
        * on the winkelwagenpagina we have a have a promo code field which is hidden by default
        */
        const showPromoCodeInput = () => {
            const promocode = document.querySelector(`#promo-code-collapse`);
            const promocodebtn = document.querySelector(`.page-template-cart [data-toggle="collapse"]`);
            const promocodeinput = document.querySelector(`#promo-code-collapse input`);
            const promocodesubmit = document.querySelector(`#promo-code-collapse #promo-submit`);

            if (typeof (promocodebtn) != 'undefined' && promocodebtn != null) {
                promocode.classList.remove('is-hidden'); // temp solution untill eactive removes html classes
                promocodeinput.classList.add('is-hidden'); // temp solution untill eactive adds html classes
                promocodesubmit.classList.add('is-hidden'); // temp solution untill eactive adds html classes

                promocodebtn.onclick = (e) => {
                    e.preventDefault();
                    promocodeinput.classList.toggle('is-hidden');
                    promocodesubmit.classList.toggle('is-hidden');
                    promocodebtn.classList.toggle('is-active');

                    if(promocode.getElementsByClassName('promo-code-warning').length > 0) {
                        promocodeinput.classList.remove('is-hidden');
                        promocodesubmit.classList.remove('is-hidden');
                    }
                }
            }

            addEventListener('change', (promocodeinput) => {
                if (promocodeinput.target.value) {
                    promocodeinput.target.classList.add('has-value');
                }
            });
        }

        /**
         * On the order form page we have to change the text of a radio button label. We collect issues like this for eActive to fix in the HTML but they calculate a few hours work
         * for this. So we do it ourselves and we send them in bulk. Also, our request to deliver the action-code is still pending, which they say it's due to our requests inbetween
         * Issue 1 which should be implemented in the HTML:
         */
        const changeTextOfRadioLabel = () => {
            const label = document.querySelector(`.main-order .form-group.afterpay label[for="order_payment_type_2"]`);
            if (typeof (label) != 'undefined' && label != null) {
                label.innerHTML = 'Riverty (voorheen Afterpay)';
            }
        }
        /**
         * Issue 2 which should be implemented in the HTML - order form page:
         */
        const changeTextOfRivertyLabel = () => {
            const label = document.querySelector(`.main-order .form-group.afterpay .pay-off`);
            if (typeof (label) != 'undefined' && label != null) {
                label.innerHTML = 'Betaal later, binnen 14 dagen';
            }
        }

        /**
         * Issue 3 which should be implemented in the HTML which reacts on the back-end of eActive - cart page:
         * We want to warn people that they can't return an e-book after they have bought it - this was mandatory for the Thuiswinkel Waarborg certification
         * Be aware: KB only. I put it here, so we have all eActive issues in one place
         */
        const addWarningToEbookInOrder = () => {
            if(themeSettings.name == 'kinderboeken') {
                const booktypes = document.querySelector(`.main-shopping-cart .product-summary-container`);
                const feedbacknotice = document.querySelector(`.main-shopping-cart .feedback-notice-warning`)

                if (typeof (booktypes) != 'undefined' && booktypes != null) {

                    if (booktypes.textContent.includes('E-book') && feedbacknotice == null) {
                        const warning = document.createElement('div');
                        document.querySelector(`.main-shopping-cart .ui-container .page-title`).after(warning);
                        warning.outerHTML = '<div class="feedback-notice feedback-notice-warning">'+
                                            '<svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m16 32c-8.83628483 0-16-7.1637153-16-16 0-8.83628483 7.16371517-16 16-16 8.8362847 0 16 7.16371517 16 16 0 8.8362847-7.1637153 16-16 16zm0-3c7.1794499 0 13-5.8205501 13-13 0-7.17944988-5.8205501-13.00000001-13-13.00000001-7.17944988 0-13.00000001 5.82055013-13.00000001 13.00000001 0 7.1794499 5.82055013 13 13.00000001 13zm0-11.2222222c-1.3388721 0-2.4242424-1.0853703-2.4242424-2.4242424v-6.14141419c0-1.33887212 1.0853703-2.42424242 2.4242424-2.42424242s2.4242424 1.0853703 2.4242424 2.42424242v6.14141419c0 1.3388721-1.0853703 2.4242424-2.4242424 2.4242424zm0 7.4343434-.1894233-.0072951c-1.2501476-.0966692-2.2348191-1.1420502-2.2348191-2.4169473 0-1.338642 1.0856004-2.4242424 2.4242424-2.4242424s2.4242424 1.0856004 2.4242424 2.4242424c0 1.2748971-.9846715 2.3202781-2.2348191 2.4169473z" fill="#333" fill-rule="evenodd"/></svg>'+
                                            '<span>Let op! Zodra je betaald hebt, wordt een e-book direct geleverd en kun je deze niet meer retourneren, zie <a href="https://www.kinderboeken.nl/veelgestelde-vragen-webshop/#nav-q_and_a_component-13">uitleg herroepen digitale producten</a>. Bij nog niet verschenen e-books kun je tot de verschijningsdatum annuleren.</span>'+
                                            '</div>';
                    }
                }
            }
        }

        addReadMoreProducts();
        whenEmptyCart();
        showPromoCodeInput();
        changeTextOfRadioLabel();
        changeTextOfRivertyLabel();
        addWarningToEbookInOrder();

        // and rerun after ajax events on the page
        $(document).ajaxComplete(function () {
            addReadMoreProducts();
            whenEmptyCart();
            showPromoCodeInput();
            addWarningToEbookInOrder();
        })
    }


    cartFunctions();
});
